var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crud_module--rsr_reset_charger"},[_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.rsrResetCharger}},[_vm._v(_vm._s(_vm.$t("label."+_vm.label)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }